import * as React from "react";
import { useCallback } from "react";
import { Field, useFormikContext } from "formik";
import DocsHelper from "util/DocsHelper";
import { Col, Row } from "common/components/layout-styles";
import { FormikInput, Icon } from "components/common";
import { Button, ControlLabel, Alert } from "components/bootstrap";
import { FormikMarkdownEditor } from "security-app/components/common/FormikComponents";
import StepListFormik from "./StepListFormik";
function EventProcedureFormFields({ onNewStep, onFromLibrary, onViewStep, onRemoveStep = () => {
} }) {
  var _a;
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const handleRemoveStep = useCallback(
    (stepId) => {
      const { steps } = values;
      const newSteps = steps.filter((step) => step.id !== stepId);
      setFieldValue("steps", newSteps);
      setFieldTouched("steps", true);
      onRemoveStep == null ? void 0 : onRemoveStep(stepId);
    },
    [setFieldTouched, setFieldValue, onRemoveStep, values]
  );
  return /* @__PURE__ */ React.createElement(Col, { $gap: "xl" }, /* @__PURE__ */ React.createElement(Col, { $align: "stretch" }, /* @__PURE__ */ React.createElement(FormikInput, { type: "text", name: "title", id: "title", label: "Title", required: true }), /* @__PURE__ */ React.createElement(
    Field,
    {
      id: "event_procedure_description",
      name: "description",
      component: FormikMarkdownEditor,
      label: "Description",
      height: 150
    }
  )), /* @__PURE__ */ React.createElement(Col, { $gap: "md" }, /* @__PURE__ */ React.createElement(Row, { $align: "center", $justify: "space-between" }, /* @__PURE__ */ React.createElement(Row, { $align: "center", $gap: "sm" }, /* @__PURE__ */ React.createElement(ControlLabel, null, "Steps"), /* @__PURE__ */ React.createElement(Button, { bsSize: "sm", onClick: onNewStep }, /* @__PURE__ */ React.createElement(Icon, { name: "add", size: "sm" }), "New Step"), /* @__PURE__ */ React.createElement(Button, { bsSize: "sm", onClick: onFromLibrary }, /* @__PURE__ */ React.createElement(Icon, { name: "assignment_add", size: "sm" }), "From Library")), /* @__PURE__ */ React.createElement(
    Button,
    {
      bsSize: "sm",
      bsStyle: "link",
      href: DocsHelper.toString(DocsHelper.PAGES.EVENT_PROCEDURES),
      target: "_blank",
      rel: "noopener noreferrer"
    },
    "Event Procedures Documentation"
  ))), ((_a = values == null ? void 0 : values.steps) == null ? void 0 : _a.length) < 1 ? /* @__PURE__ */ React.createElement(Alert, { style: { margin: 0, width: "100%" } }, "Add steps to the procedure from the options above") : /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Field, { name: "steps", component: StepListFormik, onViewStep, onRemoveStep: handleRemoveStep })));
}
export default EventProcedureFormFields;
